import { render } from "./ItemTypeTabGroup.vue?vue&type=template&id=6d3e3294"
import script from "./ItemTypeTabGroup.vue?vue&type=script&lang=js"
export * from "./ItemTypeTabGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__